import { render, staticRenderFns } from "./blok-image.vue?vue&type=template&id=139cbb3a&scoped=true&"
import script from "./blok-image.vue?vue&type=script&lang=js&"
export * from "./blok-image.vue?vue&type=script&lang=js&"
import style0 from "./blok-image.vue?vue&type=style&index=0&id=139cbb3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139cbb3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('139cbb3a')) {
      api.createRecord('139cbb3a', component.options)
    } else {
      api.reload('139cbb3a', component.options)
    }
    module.hot.accept("./blok-image.vue?vue&type=template&id=139cbb3a&scoped=true&", function () {
      api.rerender('139cbb3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/blok-image.vue"
export default component.exports